import { DialogActions, Button } from '@material-ui/core';
import checkIsMobile from 'utils/CheckIsMobile';

import 'assets/scss/consent-modal.scss';

interface ConsentModalProps {
	isOpen: boolean;
	onClose: any;
	onAccept: any;
}

const ConsentModal = ({ isOpen, onClose, onAccept }: ConsentModalProps) => {
	if (!isOpen) return null;

	const size = checkIsMobile() ? 'medium' : 'large';

	return (
		<div className="consent-modal-overlay">
			<div className="consent-modal-container">
				<div className="consent-modal-header">
					<h2>Política de Consentimiento</h2>
					<button className="close-btn" onClick={onClose}>
						✕
					</button>
				</div>

				<div className="consent-modal-body">
					<div className="consent-modal-scroll">
						<p>
							Declaro que otorgo mi consentimiento previo, libre, específico, informado e inequívoco
							a BK Servicios Financieros S.A. (“BK”), en su calidad de entidad reportante conforme a
							la Ley N°21.680 y normativa de la Comisión para el Mercado Financiero (CMF), para que
							consulte mi información contenida en el Registro de Deuda Consolidada (REDEC),
							administrado por la CMF, con la sola finalidad de evaluación del riesgo crediticio de
							la operación que estoy contratando.
						</p>

						<p>
							<strong>1. Información que será consultada</strong>
						</p>
						<p>
							Autorizo a BK a acceder en el REDEC a información relativa a mis obligaciones
							crediticias y financieras, vigentes o extinguidas, así como a mi nivel de
							endeudamiento consolidado, siempre dentro del marco permitido por la normativa
							vigente.
						</p>

						<p>
							<strong>2. Vigencia del consentimiento</strong>
						</p>
						<p>
							Durante la evaluación: BK podrá realizar consultas al REDEC por un plazo máximo de 15
							días hábiles bancarios contados desde la fecha de otorgamiento de esta autorización.
						</p>
						<p>
							En caso de aprobación del producto: Si, evaluado el riesgo en los términos señalados,
							se accede a la operación solicitada por el deudor, se entenderá extendido el
							consentimiento prestado para que BK pueda acceder al REDEC durante toda la vigencia de
							esa operación específica, con el fin exclusivo de efectuar la gestión del riesgo de
							dicha obligación, incluida la constitución de provisiones y otras exigencias
							regulatorias.
						</p>

						<p>
							<strong>3. Revocación</strong>
						</p>
						<p>
							Podré revocar mi consentimiento en cualquier momento mediante canales homólogos a los
							que fue otorgado. Declaro conocer que, tras la revocación del consentimiento, BK
							cesará el acceso y eliminará mi información proveniente del REDEC de manera inmediata,
							a menos que se encuentre habilitado para continuar accediendo conforme a la Ley
							N°21.680.
						</p>

						<p>
							<strong>4. Derechos del titular</strong>
						</p>
						<p>
							Declaro conocer que puedo ejercer mis derechos conforme a la normativa vigente ante BK
							y ante la CMF, según corresponda.
						</p>
					</div>
					<div className="consent-modal-highlight">
						<strong>
							Importante: Al aceptar estos términos, confirmo que he leído y comprendo la presente
							política de consentimiento, y autorizo a BK Servicios Financieros a consultar mi
							información en el REDEC para fines de evaluación crediticia.
						</strong>
					</div>
				</div>

				<div className="nav-button-container">
					<DialogActions>
						<Button onClick={onClose} variant="outlined" color="primary" size={size}>
							Cancelar
						</Button>
						<Button onClick={onAccept} variant="contained" color="primary" size={size}>
							Aceptar
						</Button>
					</DialogActions>
				</div>
			</div>
		</div>
	);
};

export default ConsentModal;
